import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HttpApiService } from '../../../../../shared/services/base/http-api.service';
import { ValidationMessageService } from '../../../../../shared/services/base/validation-message-handle';
import { MessageService } from 'primeng/api';
import { finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { FncService } from '../../../../../shared/services/app/fnc.service';
import { StorageSpaceModel } from '../../../../../shared/entities/storage-space.model';
import { StorageSpaceService } from '../../../../../shared/services/app/storage-space.service';

@Component({
    selector: 'app-storage-space-fnc-add-edit',
    templateUrl: './storage-space-add-edit.component.html',
    styleUrls: ['./storage-space-add-edit.component.scss']
})
export class StorageSpaceAddEditComponent implements OnInit {

    public uid: string = null;
    public storageSpaceModel: StorageSpaceModel = new StorageSpaceModel();
    public loading = false;
    public form: UntypedFormGroup;
    public dropDownWithTrashed = false;

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private formBuilder: UntypedFormBuilder,
        private httpApiService: HttpApiService,
        private validationMessageService: ValidationMessageService,
        private storageSpaceService: StorageSpaceService,
        private messageService: MessageService
    ) {
    }

    ngOnInit(): void {
        this.uid = (this.config.data) ? this.config.data.uid : null;

        this.createForm();

        if (this.uid) {
            this.getItem();
        }

        return;
    }

    onCloseDialog(storageSpace: StorageSpaceModel) {
        this.ref.close(storageSpace);
    }


    createForm(): void {
        this.form = this.formBuilder.group({
            uid: [this.storageSpaceModel.uid],
            name: [this.storageSpaceModel.name, [Validators.required, Validators.maxLength(200)]],
            fnc_id: [this.storageSpaceModel.fnc_id, Validators.required],
            storage_type_id: [this.storageSpaceModel.storage_type_id, Validators.required],
        });
    }

    getItem(): void {
        this.loading = true;
        this.dropDownWithTrashed = true;
        this.storageSpaceService.get(this.uid)
            .pipe(finalize(() => {this.loading = false; this.dropDownWithTrashed = false;}))
            .subscribe((response: any) => {
                this.storageSpaceModel.map(response.payload);
                this.form.patchValue(this.storageSpaceModel);
            });
    }


    onCancel(): void {
        this.ref.close(null);
    }

    checkIfFormValid(): boolean {
        if (this.form.invalid) {
            this.messageService.add({
                severity: 'error',
                summary: 'Formularul nu este valid!',
                detail: 'Vericficati toate campurile si incercati din nou.'
            });
            this.form.markAllAsTouched();
            return false;
        }
        return true;
    }

    onSave(): void {
        if (!this.checkIfFormValid()) {
            return;
        }
        this.loading = true;
        const data = this.form.getRawValue();
        this.storageSpaceService.set(data)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: any) => {
                this.storageSpaceModel.map(response.payload);
                this.form.patchValue(this.storageSpaceModel);
                this.messageService.add({
                    severity: 'success',
                    summary: 'Spatiul de stocare a fost salvat cu success!'
                });
                this.ref.close(this.storageSpaceModel);
            }, err => {
                if (err instanceof HttpErrorResponse) {

                    this.validationMessageService.serverSideValidation(err, this.form, '', true);
                }
            });
    }

}
